import { GroupListOrderKey } from '../domain';
import { useListOrder } from '../../filter/hooks/useListOrder';

export const useGroupListOrder = () => {
  return useListOrder(GroupListOrderKey, 'groupOrderBy', true);
};
